import { NotificationManager } from "components/common/react-notifications";
import { toast } from "helpers/Utils";
import { GET_ASSIGN_LEGAL_EXECUTIVE, GET_ASSIGN_LEGAL_EXECUTIVE_FAILED, GET_ASSIGN_LEGAL_EXECUTIVE_SUCCESS, USERS_GET_LIST, USERS_GET_LIST_FAILED, USERS_GET_LIST_SUCCESS, USER_ADD_USER_FAILED, USER_ADD_USER_SUCCESS, USER_GET_ASSIGN_USER, USER_GET_ASSIGN_USER_FAILED, USER_GET_ASSIGN_USER_SUCCESS, USER_GET_LEGAL_SUBEXECUTIVE, USER_GET_LEGAL_SUBEXECUTIVE_FAILED, USER_GET_LEGAL_SUBEXECUTIVE_SUCCESS, USER_GET_STATUS_BUCKET, USER_GET_STATUS_BUCKET_FAILED, USER_GET_STATUS_BUCKET_SUCCESS, USER_UPDATE_PASSWORD, USER_UPDATE_PASSWORD_FAILED, USER_UPDATE_PASSWORD_SUCCESS, USER_UPDATE_USER_FAILED, USER_UPDATE_USER_SUCCESS, GET_INTERNAL_LEGAL_EXPERT_SUCCESS, GET_PARTNER_USERS, GET_PARTNER_USERS_SUCCESS, GET_PARTNER_USERS_FAILED, GET_PARTNER_USERS_REPORT, GET_PARTNER_USERS_REPORT_SUCCESS, GET_PARTNER_USERS_REPORT_FAILED, ADD_USER_FOLLOW_UP, ADD_USER_FOLLOW_UP_SUCCESS, ADD_USER_FOLLOW_UP_FAILED, GET_SINGLE_PARTNER_USER, GET_SINGLE_PARTNER_USER_SUCCESS, GET_SINGLE_PARTNER_USER_FAILED, CHANGE_PARTNER_USER, CHANGE_PARTNER_USER_SUCCESS, CHANGE_PARTNER_USER_FAILED, GET_EXECUTIVE_NAME, GET_EXECUTIVE_NAME_SUCCESS, GET_EXECUTIVE_NAME_FAILED, GET_DAILY_TASK_LIST, GET_DAILY_TASK_LIST_SUCCESS, GET_DAILY_TASK_LIST_FAILED, UPLOAD_RECORDING, UPLOAD_RECORDING_SUCCESS, UPLOAD_RECORDING_FAILED, GET_PARTNER_CASES, GET_PARTNER_CASES_SUCCESS, GET_PARTNER_CASES_FAILED, DOWNLOAD_DAILY_TASK, DOWNLOAD_DAILY_TASK_SUCCESS, DOWNLOAD_DAILY_TASK_FAILED } from "./Action";

let initialState = {
  userData: {},
  statusBucket: {},
  assignUser: [],
  legalExecutive: [],
  legalSubExecutive: [],
  message: "",
  userUpdateMessage: "",
  loading: false,
  internalLegalExecutive: [],
  partnerUsersData: [],
  followUpList: [],
  count: null,
  executiveNames: [],
  reportData: [],
  dailyTaskData: [],
  dailyTaskLoading: false,
  partnerCases: [],
  uploadRecordingLoading: false
};

export default function (state = initialState, action) {
  switch (action.type) {
    case USERS_GET_LIST:
      return { ...state, loading: true };

    case USERS_GET_LIST_SUCCESS:
      NotificationManager.success("All User Data Fetched !", "Success !", 3000, null, null, "filled");
      return { ...state, userData: action.data, loading: false };

    case USERS_GET_LIST_FAILED:
      return { ...state, message: action.message, loading: false };

    case USER_GET_STATUS_BUCKET:
      return { ...state };

    case USER_GET_STATUS_BUCKET_SUCCESS:
      return { ...state, statusBucket: action.data };

    case USER_GET_STATUS_BUCKET_FAILED:
      return { ...state, message: action.message };

    case USER_GET_ASSIGN_USER:
      return { ...state };

    case USER_GET_ASSIGN_USER_SUCCESS:
      return { ...state, assignUser: action.data };

    case USER_GET_ASSIGN_USER_FAILED:
      return { ...state, message: action.message };

    case GET_ASSIGN_LEGAL_EXECUTIVE:
      return { ...state };

    case GET_ASSIGN_LEGAL_EXECUTIVE_SUCCESS:
      return { ...state, legalExecutive: action.data };

    case GET_INTERNAL_LEGAL_EXPERT_SUCCESS:
      return { ...state, internalLegalExecutive: action.data };

    case GET_ASSIGN_LEGAL_EXECUTIVE_FAILED:
      return { ...state, message: action.message };

    case USER_GET_LEGAL_SUBEXECUTIVE:
      return { ...state };

    case USER_GET_LEGAL_SUBEXECUTIVE_SUCCESS:
      return { ...state, legalSubExecutive: action.data };

    case USER_GET_LEGAL_SUBEXECUTIVE_FAILED:
      return { ...state, message: action.message };

    case USER_UPDATE_USER_SUCCESS:
      NotificationManager.success("User Updated !", "success", 3000, null, null, "filled");
      return { ...state, userUpdateMessage: "User Updated Successfully !" };

    case USER_UPDATE_USER_FAILED:
      return { ...state, userUpdateMessage: "Failed to Update User !" };

    case USER_ADD_USER_SUCCESS:
      if (action.data?.Status === 200) {
        NotificationManager.success("User Added Successfully ! !", "success", 3000, null, null, "filled");
      } else {
        NotificationManager.error("Something Wrong !", "Failed", 3000, null, null, "filled");
      }
      return { ...state, message: "User Added Successfully !" };

    case USER_ADD_USER_FAILED:
      return { ...state, message: "Failed to add User !" };

    case USER_UPDATE_PASSWORD:
      return { ...state };

    case USER_UPDATE_PASSWORD_SUCCESS:
      toast("Password has been updated !", "", "success");
      return { ...state, message: "Password has been updated !" };

    case USER_UPDATE_PASSWORD_FAILED:
      toast("Failed to update password !", "", "error");
      return { ...state, message: "Failed to update password !" };

    case GET_PARTNER_USERS:
      return { ...state };

    case GET_PARTNER_USERS_SUCCESS:
      return { ...state, partnerUsersData: action.data, count: action.count };

    case GET_PARTNER_USERS_FAILED:
      return { ...state, message: action.message };

    case GET_PARTNER_USERS_REPORT:
      return { ...state };
    case GET_PARTNER_USERS_REPORT_SUCCESS:
      return { ...state, reportData: action.data };
    case GET_PARTNER_USERS_REPORT_FAILED:
      return { ...state, message: action.message };

    case GET_SINGLE_PARTNER_USER:
      return { ...state };
    case GET_SINGLE_PARTNER_USER_SUCCESS:
      return { ...state, followUpList: action.data };
    case GET_SINGLE_PARTNER_USER_FAILED:
      return { ...state };

    case ADD_USER_FOLLOW_UP:
      return { ...state };
    case ADD_USER_FOLLOW_UP_SUCCESS:
      toast("Follow Up Added !", "", "success");
      return { ...state };
    case ADD_USER_FOLLOW_UP_FAILED:
      toast("Something went wrong !", "", "error");
      return { ...state };

    case CHANGE_PARTNER_USER:
      return { ...state };
    case CHANGE_PARTNER_USER_SUCCESS:
       toast("Excutive Change Successfully !", "", "success");
      return { ...state };

    case CHANGE_PARTNER_USER_FAILED:
      toast("Something went wrong !", "", "error");
      return { ...state };

    case GET_EXECUTIVE_NAME:
      return { ...state };
    case GET_EXECUTIVE_NAME_SUCCESS:
      return { ...state, executiveNames: action.data };
    case GET_EXECUTIVE_NAME_FAILED:
      return { ...state, message: action.message };

    case GET_DAILY_TASK_LIST:
      return { ...state, dailyTaskLoading: true };
    case GET_DAILY_TASK_LIST_SUCCESS:
      return { ...state, dailyTaskLoading: false, dailyTaskData: action.payload };
    case GET_DAILY_TASK_LIST_FAILED:
      return { ...state, dailyTaskLoading: false, dailyTaskData: [] };

    case UPLOAD_RECORDING:
      return { ...state, uploadRecordingLoading: true };
    case UPLOAD_RECORDING_SUCCESS:
      return { ...state, uploadRecordingLoading: false };
    case UPLOAD_RECORDING_FAILED:
      return { ...state, uploadRecordingLoading: false };

    case GET_PARTNER_CASES:
      return { ...state };
    case GET_PARTNER_CASES_SUCCESS:
      return { ...state, partnerCases: action.payload };
    case GET_PARTNER_CASES_FAILED:
      return { ...state, partnerCases: [] };

    case DOWNLOAD_DAILY_TASK:
      return { ...state, dailyTaskLoading: true };
    case DOWNLOAD_DAILY_TASK_SUCCESS:
      return { ...state, dailyTaskLoading: false, reportData: action.data };
    case DOWNLOAD_DAILY_TASK_FAILED:
      return { ...state, dailyTaskLoading: false };

    default:
      return { ...state };
  }
}
